// Theme asset; native Shopify cents are NOT necessarily GST-inclusive.
// Formula-priced calculators retain their separate inclusive-price contract.
(function (global) {
  "use strict";
  function breakdown(cents, taxesIncluded, taxable) {
    cents = Math.round(Number(cents));
    if (!Number.isFinite(cents) || cents < 0) throw new Error("Invalid Shopify price");
    var subtotal = taxesIncluded && taxable ? Math.round(cents / 1.1) : cents;
    var gst = !taxable ? 0 : taxesIncluded ? cents - subtotal : Math.round(cents / 10);
    return { subtotal: subtotal, gst: gst, total: taxesIncluded ? cents : cents + gst };
  }
  global.SignPortalNativeTax = { breakdown: breakdown };
})(typeof window === "undefined" ? globalThis : window);
